export default "__VITE_ASSET__CBjn6Eov__"